export const FORGOT_CHANGE_USERNAME = 'FORGOT_CHANGE_USERNAME';

export function changeUsername(username) {
  return { type: FORGOT_CHANGE_USERNAME, username };
}
